<template>
  <div class="bloco">
    <div>
      <div class="row">
        <div class="col-md-11">
          <div class="titulo">Suporte</div>
          <div class="subTitulo">Registre sua solicitação para atendimento da nossa equipe.</div>
        </div>
        <div class="col-md-1">
          <div class="float-right">

          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="borda"></div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div v-once id="hs-form"></div>
        </div>
      </div>

      <loading :active.sync="isLoading" color="#008e75" :can-cancel="true"></loading>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  mounted() {
    const script = document.createElement("script");
    script.src = "https://res.cloudinary.com/das1rnjvi/raw/upload/v1674582202/bluelogic/v2_x8uau3.js";
    document.body.appendChild(script);
    script.addEventListener("load", () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          region: "na1",
          portalId: "8761732",
          formId: "6eef5d36-5bfe-4955-b4ff-5bcba871661d",
          target: '#hs-form'
        })
      }
    })
  },
}
</script>

<style lang="scss" scoped>
.bloco {
  margin-top: 10px;
  background-color: #fff;
  padding: 40px;
  border-radius: 0.25rem;

  .titulo {
    font-size: 25px;
    color: #182E4A;
    margin-bottom: 10px;
    font-weight: bold;
  }

  .subtitulo {
    margin-bottom: 10px;
  }

  .borda {
    margin-top: 15px;
    margin-bottom: 15px;
    border-bottom: solid 1px #edeff4;
  }

  .formulario {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .btn-webreceita {
    margin-top: 30px;
    margin-bottom: 10px;
    background-color: #182E4A;
    padding: 5px 30px;

    &.botaoTopo {
      float: right;
    }
  }

  .filterButton {
    background-color: #182E4A;
    padding: 0 20px;
  }

  .cadastra {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
